import { IndustryResponse } from '../../../api/models/industry-response';

const NAMES = [
  'Technology', 'Healthcare', 'Finance', 'Education', 'Retail', 'Manufacturing',
  'Real Estate', 'Hospitality', 'Entertainment', 'Automotive', 'Telecommunications',
  'Energy', 'Agriculture', 'Construction', 'Transportation', 'Professional Services',
  'Non-Profit', 'Government', 'Other'
];

export const DEMO_INDUSTRIES: IndustryResponse[] = NAMES.map((name, i) => ({
  id: i + 1,
  name,
  isActive: true
}));
